import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EntitiesService } from 'src/app/configuration/entities.service';
import { ViewsService } from '../../views.service';
import groupBy from 'lodash/groupBy';

@Component({
  selector: 'app-view-component-add',
  templateUrl: 'view-component-add.component.html',
  styleUrls: ['view-component-add.component.scss'],
})
export class ViewComponentAddComponent implements OnInit {

  public components: any[] = [];

  constructor(
    private viewsService:ViewsService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService:MessageService
  ) { 
  }

  ngOnInit(): void {
    this.loadComponents();
  }
  
  loadComponents(){
    this.viewsService.getViewComponents(this.config.data.view_code).subscribe(
      data => {
        this.components = data;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  selectComponent(component){
    this.dynamicDialogRef.close(component);
  }

}
